import type { SVGProps } from "react";

/**
 * Peel — a vegetable peeler scraping across a carrot / vegetable.
 */
export function PeelIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Vegetable body (carrot-like) */}
      <path
        d="M22 12c-2 4-4 8-3 16 0 6 4 10 10 10s10-4 10-10c1-8-1-12-3-16"
        fill="currentColor"
        opacity={0.12}
      />
      <path
        d="M22 12c-2 4-4 8-3 16 0 6 4 10 10 10s10-4 10-10c1-8-1-12-3-16"
        stroke="currentColor"
        strokeWidth={1.2}
        opacity={0.4}
        fill="none"
      />
      {/* Peeler blade */}
      <rect
        x={10}
        y={18}
        width={12}
        height={4}
        rx={1}
        fill="currentColor"
        opacity={0.7}
      />
      {/* Peeler handle */}
      <rect
        x={6}
        y={16}
        width={6}
        height={8}
        rx={1.5}
        fill="currentColor"
        opacity={0.5}
      />
      {/* Peel curl */}
      <path
        d="M22 22c2-1 4-1 5 1s-1 3-3 2"
        stroke="currentColor"
        strokeWidth={1}
        strokeLinecap="round"
        opacity={0.5}
        fill="none"
      />
    </svg>
  );
}
